import {getKeycloak} from '../api/interceptors';
import apiClient from '../api/client';
import {ENDPOINTS} from '../api/endpoints';

export const userService = {

    hasRole: (expectedRole) => {
        const keycloak = getKeycloak();
        const roles = keycloak?.realmAccess?.roles || [];
        return Promise.resolve(roles.includes(expectedRole));
    },

    generateToken: async () => {
        const response = await apiClient.get(
            `${ENDPOINTS.USERS}/tableau/generate-token`
        );
        return response.data;
    }

};